import { render, staticRenderFns } from "./ExpiredBooking.vue?vue&type=template&id=27236608"
import script from "./ExpiredBooking.vue?vue&type=script&lang=js"
export * from "./ExpiredBooking.vue?vue&type=script&lang=js"
import style0 from "./ExpiredBooking.vue?vue&type=style&index=0&id=27236608&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports